import EmptyStarIcon from '../Icons/EmptyStar';
import FilledStarIcon from '../Icons/FilledStar';
import HalfStarIcon from '../Icons/HalfStart';

type Props = {
  className?: string;
  averageScore: number;
};

export default function ReviewsSectionRating({className, averageScore}: Props) {
  const stars = [];
  const isInteger = averageScore % 1 === 0;

  for (let i = 1; i <= 5; i++) {
    if (isInteger && i <= averageScore) {
      stars.push(
        <div key={i} className="inline-block mr-[5px]">
          <FilledStarIcon className="fill-current text-inherit w-6 h-6" />
        </div>,
      );
    } else if (!isInteger && i < averageScore) {
      stars.push(
        <div key={i} className="inline-block mr-[5px]">
          <FilledStarIcon className="fill-current text-inherit w-6 h-6" />
        </div>,
      );
    } else if (!isInteger && i === Math.ceil(averageScore)) {
      stars.push(
        <div key={i} className="inline-block mr-[5px]">
          <HalfStarIcon className="fill-current text-inherit w-6 h-6" />
        </div>,
      );
    } else {
      stars.push(
        <div key={i} className="inline-block mr-[5px]">
          <EmptyStarIcon className="fill-current text-inherit w-6 h-6" />
        </div>,
      );
    }
  }

  return <div className={className}>{stars}</div>;
}
